
import XButton from 'vux/src/components/x-button/index.vue'

import SetAge from './components/SetAge';
import {HeadBar, CellRow, ICount} from '@/components';
import {mapGetters} from 'vuex';

export default {
name: 'check-in-number',
components: {
HeadBar,
ICount,
XButton,
CellRow,
SetAge,
},
data(){
return {
isShowPopupAge: false,
curChildIdx: 0,
curAge: 0,
maxChildren: 3,
maxAdults: 10,
q: {
rooms: 1,
adult: 1,
children: 0,
ages: [],
},
};
},
computed: {
...mapGetters(['getRooms', 'getAdults', 'getChildren', 'getAges']),
},
mounted(){
this.q.rooms = this.getRooms;
this.q.children = this.getChildren;

setTimeout(() => {
this.q.adult = this.getAdults;
this.q.ages = this.getChildren > 0 ? String(this.getAges).split(',') : [];
}, 50);
},
watch: {
'q.children': {
handler(cur){
if(cur > this.q.ages.length){
this.q.ages.push(0);
}else{
this.q.ages.pop();
}
}
},
'q.rooms': {
handler(cur){
this.maxChildren = cur * 3;
this.maxAdults = cur * 10;

if(this.q.adult > this.maxAdults){
this.q.adult = this.maxAdults;
}

if(this.q.children > this.maxChildren){
this.q.children = this.maxChildren;

this.q.ages = this.q.ages.slice(0, this.maxChildren + 1);
}
}
},
},
methods: {
onBack(){
this.$router.back();
},

onChangeAge(idx){
this.isShowPopupAge = true;
this.curChildIdx = idx;
this.curAge = this.q.ages[idx];
},

onGetAge(age){
this.$set(this.q.ages, this.curChildIdx, age - 1);
this.curAge = age - 1;
},

onReturnAges(){
this.$store.dispatch('setRooms', this.q.rooms);
this.$store.dispatch('setAdults', this.q.adult);
this.$store.dispatch('setChildren', this.q.children);
this.$store.dispatch('setAges', this.q.ages);
this.onBack();
},
},
}



// WEBPACK FOOTER //
// ./src/views/check-in-number/check-in-number.vue